import * as React from 'react';
import { useState } from 'react';
import styled from 'styled-components';

import Arrow from 'assets/icons/arrows/arrow-down-16.svg';

import { ActiveProposals } from 'components/Header/ActiveProposals/ActiveProposals';
import { linkStyles } from 'components/Header/Header';

import { cardBoxShadow, respondDown } from 'styles/mixins';
import { Breakpoints, COLORS } from 'styles/style-constants';

const Menu = styled.div`
    position: relative;
    padding: 0 1rem;

    ${respondDown(Breakpoints.lg)`
        padding: 0 1.2rem;
    `}
`;

const MenuHead = styled.div`
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 0.8rem;
    padding: 0.2rem;

    ${respondDown(Breakpoints.md)`
        display: none;
    `}
`;

const MenuHeadTitle = styled.div`
    ${linkStyles};
    font-size: 1.6rem;
    color: ${COLORS.textPrimary};
    display: flex;
    align-items: center;
    gap: 0.8rem;
    white-space: nowrap;
`;

const MenuLinks = styled.div<{ $isOpen: boolean }>`
    ${cardBoxShadow};
    display: ${({ $isOpen }) => ($isOpen ? 'flex' : 'none')};
    flex-direction: column;
    position: absolute;
    background: ${COLORS.white};
    padding: 2.4rem;
    left: 0;
    border-radius: 0.5rem;

    a {
        width: fit-content;

        &:not(:last-child) {
            margin: 0 0 1.2rem 0;
        }
    }

    ${respondDown(Breakpoints.md)`
        display: flex;
        position: relative;
        box-shadow: unset;
        align-items: center;
        
        a:not(:last-child) {
            margin-bottom: 2.4rem;
        }
    `}
`;

interface Props {
    links: React.ReactNode;
    title: string;
    counts?: { active: number; discussion: number };
    indicator?: React.ReactNode;
}

const ExpandedMenu = ({ links, title, counts, indicator }: Props): React.ReactNode => {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <Menu onMouseEnter={() => setIsOpen(true)} onMouseLeave={() => setIsOpen(false)}>
            <MenuHead>
                <MenuHeadTitle>
                    {title}
                    {indicator}
                    <ActiveProposals
                        discussionCount={counts?.discussion}
                        activeCount={counts?.active}
                    />
                </MenuHeadTitle>
                <Arrow />
            </MenuHead>
            <MenuLinks $isOpen={isOpen}>{links}</MenuLinks>
        </Menu>
    );
};

export default ExpandedMenu;
